//ページ内リンク
$(window).on("load", function () {
  let headerHeight = $("header").outerHeight();
  let urlHash = location.hash;
  if (urlHash) {
    let position = $(urlHash).offset().top - headerHeight;
    $("html, body").animate({ scrollTop: position }, 0);
  }
});

jQuery(function ($) {
  //TOP : Product
  $(".product-list__wrap:not(:first-of-type)").hide();
  $(".product-nav li").on("click", function () {
    $(".product-list__wrap").hide();
    var clickId = $(this).attr("id");
    $("#c-" + clickId).show();
  });

  $(".product-select select").change(function () {
    $(".product-list__wrap").hide();
    var clickId = $(this).val();
    $("#c-" + clickId).show();
  });

  // 初期表示数・追加表示数
  if (window.matchMedia("(max-width: 768px)").matches) {
    var init = 5;
    var more = 5;
  } else {
    var init = 6;
    var more = 6;
  }

  // 初期表示数以降のリスト内容を非表示に
  $(".product-list li:nth-child(n+" + (init + 1) + ")").hide();

  //初期表示数以下であればMoreボタンを非表示
  $(".product-list")
    .filter(function () {
      return $(this).find("li").length <= init;
    })
    .next(".product-list__more")
    .hide();

  // Moreボタンクリックで指定数表示
  $(".product-list__more").on("click", function () {
    let this_list = $(this).prev(".product-list");
    this_list.find("li:hidden").slice(0, more).slideToggle();

    if (this_list.find("li:hidden").length == 0) {
      $(this).fadeOut();
    }
  });

  //
  $(".top-case_slider").slick({
    infinite: false,
    autoplay: false,
    appendArrows: $(".arrows"),
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1064,
        settings: {
          dots: true,
        },
      },
    ],
  });

  //会社ヒストリー位置調整
  if ($(".case .head .inner").hasClass("slide-pos")) {
    var historyTtlPos = $(".case .head .inner").offset().left + 30;
    $(".slider-wrap").css("padding-left", historyTtlPos);
    console.log(historyTtlPos);
  }

  //実績一覧
  // 初期表示数・追加表示数
  if (window.matchMedia("(max-width: 768px)").matches) {
    var init = 5;
    var more = 5;
  } else {
    var init = 5;
    var more = 5;
  }

  // 初期表示数以降のリスト内容を非表示に
  $(".case-list .item:nth-child(n+" + (init + 1) + ")").hide();

  //初期表示数以下であればMoreボタンを非表示
  $(".case-list")
    .filter(function () {
      return $(this).find("li").length <= init;
    })
    .next(".case-list__more")
    .hide();

  // Moreボタンクリックで指定数表示
  $(".case-list__more").on("click", function () {
    let this_list = $(this).prev(".case-list");
    this_list.find("li:hidden").slice(0, more).slideToggle();

    if (this_list.find("li:hidden").length == 0) {
      $(this).fadeOut();
    }
  });

  //ページ内リンク
  $(".page-links").on("click", function () {
    let time = 400;
    let header = $("header").height();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $("html,body").animate(
      {
        scrollTop: targetY,
      },
      time,
      "swing"
    );
    return false;
  });

  //ハンバーガーメニュー
  $(".hamburger").on("click", function () {
    $(this).toggleClass("is-active");
    $("header").toggleClass("is-open");
  });

  $(".fixed-menu .js-close").on("click", function () {
    $(".fixed-menu .menu").removeClass("is-active");
  });

  //コンテンツフェードイン
  $(window).on("scroll", function () {
    $(".js-anim").each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight) {
        $(this).addClass("is-anim");
      }
    });
  });

  //コンテンツ右からスライドイン
  $(window).on("scroll", function () {
    $(".js-anim-right").each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight) {
        $(this).addClass("is-anim");
      }
    });
  });

  //コンテンツ左からスライドイン
  $(window).on("scroll", function () {
    $(".js-anim-left").each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight) {
        $(this).addClass("is-anim");
      }
    });
  });

  //ページトップ
  $(".to-top").on("click", function () {
    $("body, html").animate(
      {
        scrollTop: 0,
      },
      500
    );
    return false;
  });

  //faq
  $(".item-a").hide();
  $(".item").on("click", function () {
    $(this).children(".item-a").slideToggle();
    $(this).toggleClass("is-active");
  });

  //sns
  var href = location.href; //1.URLを取得しエンコードする
  var getTitle = $("title").html(); //2.ページのタイトルを取得

  //3.URLを取得しエンコードする
  var snsUrl = encodeURIComponent(href);
  var snsTitle = encodeURIComponent(getTitle);

  $(".sns_link").each(function () {
    var sns_obj = $(this).attr("id"); //4.ID名を取得
    var snsCase = sns_obj;
    //5.IDを判定してリンク先を出力する
    switch (snsCase) {
      case "sns_tw":
        $(this).attr("href", "http://twitter.com/share?url=" + snsUrl);
        break;

      case "sns_fb":
        $(this).attr("href", "http://www.facebook.com/sharer.php?u=" + snsUrl);
        break;

      case "sns_line":
        $(this).attr(
          "href",
          "http://line.me/R/msg/text/?" + snsTitle + "%20" + snsUrl
        );
        break;
    }
  });

  //copyright年更新
  document.getElementById("current-year").innerText = new Date().getFullYear();
});
